/**
 * @generated SignedSource<<3f36a9772b8e1822c79d4f382b53945d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type job_useMissingSubtypesJob$data = {
  readonly jobsSpecializations: ReadonlyArray<{
    readonly groupIndex: number | null | undefined;
    readonly specialization: {
      readonly id: string;
      readonly name: string;
      readonly rawId: number | null | undefined;
    } | null | undefined;
  }>;
  readonly " $fragmentType": "job_useMissingSubtypesJob";
};
export type job_useMissingSubtypesJob$key = {
  readonly " $data"?: job_useMissingSubtypesJob$data;
  readonly " $fragmentSpreads": FragmentRefs<"job_useMissingSubtypesJob">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "job_useMissingSubtypesJob",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "JobsSpecialization",
      "kind": "LinkedField",
      "name": "jobsSpecializations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupIndex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Specialization",
          "kind": "LinkedField",
          "name": "specialization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rawId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "636a444d2f2d8733579fe723305fd8cb";

export default node;
